module.exports = {
    pleaseWait:"Please wait",
    FAQ:"FAQ",
    TC:"T&C",
    UserGuide:"User Guide",
    AccountFAQ:"FAQ",
    AccountTC:"T&C",
    Submit:"Submit",
    change:"Change",
    English:"English",
    Myanmar:"Myanmar",
    Logout:"Log out",
    register:"Register",
    getCode:"Resend",
    language0:"Language",
    language:"Choose Language",
    Daily:"Daily",
    Weekly:"Weekly",
    ChancesLeft:"My Points",
    BuyChances:"Buy More Chances",
    BuyMoreChancesCopy:"Get more chances & keep playing",
    BuyMoreChancesWin:"to win",
    BuyMoreChancesHighlight:"amazing rewards!",
    CurrentChances:"Your current chances:",
    languageTips:"Choose your language here",
    loginTips:"Enter a phone number",
    phoneNumber:"Phone Number",
    select:"Select a Package",
    Monthly:"Monthly",
    Level:"Level",
    Rank:"Rank",
    RedeemCenter:"Redeem Center",
    Categories:"Categories",
    HomeNavPrizes:"Prizes",
    PrizeWeeklyTitle:"Weekly prizes",
    PrizeMonthlyTitle:"Monthly prizes",
    PrizeFirstWinner:"1st Winner",
    PrizeSecondWinner:"2nd Winner",
    PrizeThirdWinner:"3rd Winner",
    PrizeFourthToTenthWinners:"4th–10th Winners",
    PrizeEleventhToTwentiethWinners:"11th–20th Winners",
    ChooseHere:"Choose Here",
    game1T:"AI Training",
    game2T2:"Rank Mode",
    game3T:"Team Mode",
    game4T:"Endless Challenge",
    game1C:"Your smart quiz partner! Improve your Skills!",
    game3C:"Challenge your knowledge together with your friends!",
    game4C2:"You must answer each question correctly within 10 seconds to continue. The game ends when you select a wrong answer or run out of time.",
    WordQuizAITraining:"AI Training",
    WordQuizAITrainingC:"Your smart quiz partner! Improve your skills!",
    WordQuizRankedMode:"Ranked Mode",
    WordQuizRankedModeC:"Challenge other players in real-time quizzes!",
    WordQuizTeamMode:"Team Mode",
    WordQuizTeamModeC:"Challenge your knowledge together with your friends!",
    WordQuizEndlessMode:"Endless Mode",
    WordQuizEndlessModeC:"Test your speed & knowledge in endless mode",
    Ranking:"Ranking",
    rankList:"Rank List",
    RedeemList:"Redeem List",
    RewardClaimTitle:"Your Rewards",
    RewardClaimPopupTitle:"CONGRATULATIONS!",
    RewardClaimPopupContent:"You've received a prize! Tap to claim it now.",
    RewardClaimNow:"CLAIM NOW",
    RewardClaiming:"CLAIMING...",
    RewardNoPending:"No prizes are waiting to be claimed.",
    RewardExpiresAt:"Claim before",
    Settings:"Settings",
    Back:"Back",
    game1Tips1:"Select difficulty levels",
    Easy:"Easy",
    Medium:"Medium",
    Hard:"Hard",
    RobotMatchMaking:"Match making",
    RobotPlayer:"Player",
    RobotAiBot:"AI Bot",
    PlayAgain:"Play Again!",
    WaitingTips:"Waiting for friends to join",
    GameOver:"Game Over",
    GameWinTitle:"You Win",
    GameLoseTitle:"You Lose",
    GameDrawTitle:"Draw",
    GameWinLead:"Brilliant skills!",
    GameWinMessage:"You have won the game.",
    GameLoseLead:"So close!",
    GameLoseMessage:"Better luck next time.",
    GameDrawMessage:"A close match. You both scored the same.",
    SingleQuizOverTitle:"Quiz Over!",
    SingleQuizOverMessagePrefix:"All questions complete. Check out your",
    SingleQuizOverMessageHighlight:"final score.",
    CreateRoom:"Create Room",
    JoinRoom:"Join Room",
    YourFriend:"Your Friend",
    RoomID:"Room ID",
    enterRoomID:"Please Enter Room ID",
    MatchingLevel:"Matching range level",
    Waiting:"Waiting",
    Congratulations:"Congratulations, you won",
    YourScore:"Your score",
    OpponentScore:"Opponent's score",
    StartNow:"Start Now!",
    subscribe:'Subscribe',
    subscribeNow:'Subscribe now',
    notChances:'Not Enough Chances!',
    Later:'Later',
    Points:'Points',
    Chances:'Chances',
    MemberSince:'Member Since',
    currentLevel:'Your current Level',
    YouCanRedeem:'You can redeem',
    moreTimes:'more times.',
    Redeem:'Redeem',
    congratulations:'CONGRATULATIONS',
    redeemTips:'You are about to redeem',
  NoRedeemRecords:'No one has redeemed now,  please start to play game and redeem now!',
  NoRankList:'No one has points now, please start to play game.',
    unsub_tip:'For unsubscription, send OFF to 508',
    Unsubscribe:'UNSUBSCRIBE',
  homeGame1T:'Brain Games',
  homeGame1C:'Play fun puzzle and challenge games, and train your brain!',
  homeGame2T:'Quiz Center',
  homeGame2C:'Think fast! Pick the right answer out of 3 and win the game!',
  NoGameList:'No game!',
  play:'play',
  WordQuiz:'Word Quiz',
  GuessWords:'Guess Words',
  QuizCenterGuessWordsC:'Guess the words from the image. Let’s go!',
  MusicQuiz:'Music Quiz',
  QuizCenterMusicQuizC:'Hear the tune&answer the correct song.',
  VideoQuiz:'Video Quiz',
  QuizCenterVideoQuizC:'Watch the clip&guess the correct film.',
  next:'Next',
  image_input_placeholder:"Enter the correct answer here",
  rank:"RANKING",
  no_data:"No Data",
  sharePanelTitle:'Share with friends',
  sharePanelTips:'Choose a platform below and send your invite link directly.',
  shareMore:'More Options',
  invitation:'Invitation',
  copy:'Copy',
  CopySucceeded:'Copied successfully',
  referralTips1:"I found something interesting and wanted to share it with you. Come and join me",
  AnnouncementPopupTitle:'ANNOUNCEMENT',
  AnnouncementPopupContent:'Starting in August, 3 winners from ranks 1-50 will be randomly selected to win Grand Prizes of 1,500,000, 1,000,000, and 500,000 kyats.',
  AnnouncementPopupAction:'LET’S GET',
  AnnouncementPopupClose:'Close announcement',
  one_time_purchase:"One-Time Purchase",
  LiveQuiz:'Live Quiz',
  Questions:'Questions',
  Question:'Question',
  LiveQuizStartsAt:'Starts at',
  LiveQuizStartsIn:'Starts in',
  LiveQuizReserveEndsIn:'Reservation ends in',
  LiveQuizReserve:'Reserve for free',
  LiveQuizReserved:'Reserved successfully',
  LiveQuizReservationClosed:'Reservation has closed',
  LiveQuizEnterLobby:'Enter lobby',
  LiveQuizEnter:'Enter live quiz',
  LiveQuizSpectatorHint:'You are spectating and cannot answer questions.',
  LiveQuizAnswerReveal:'Answer reveal',
  LiveQuizParticipationGift:'Participation gift',
  LiveQuizParticipatedQuestions:'You\'ve participated in {count} questions',
  LiveQuizGiftSurprise:'Get your surprise',
  LiveQuizGiftBox:'Gift box',
  LiveQuizGiftUpToPoints:'Up to {points} Points',
  LiveQuizGiftClaiming:'Claiming...',
  LiveQuizContinueSpectating:'Got it, continue spectating',
  LiveQuizRemindTomorrow:'Remind me to claim tomorrow',
  LiveQuizCloseGift:'Close gift box',
  LiveQuizPointsReceived:'You received {points} points',
  LiveQuizEnded:'This round has ended',
  LiveQuizConnectionError:'Unable to connect to live quiz',
  LiveQuizReconnectHint:'The connection was interrupted. Reconnect to continue.',
  LiveQuizReconnect:'Reconnect',
  LiveQuizReadyPlayers:'{count} players ready',
  LiveQuizReadyTitle:'Get ready for the live quiz',
  LiveQuizChallenge:'Quiz challenge',
  LiveQuizSchedule:'Live quiz schedule',
  LiveQuizHistory:'History',
  LiveQuizToday:'Today',
  LiveQuizTomorrow:'Tomorrow',
  LiveQuizStartingSoon:'Starting soon',
  LiveQuizNoRounds:'No rounds are available for this day.',
  LiveQuizLoadMore:'Load more',
  LiveQuizLoading:'Loading...',
  LiveQuizPeople:'people',
  LiveQuizClearedLevel:'cleared the level in this round.',
  LiveQuizBackToSchedule:'Back to schedule',
  LiveQuizStatusEnded:'Ended',
  LiveQuizStatusBooking:'Booking',
  LiveQuizStatusReserved:'Reserved',
  LiveQuizStatusPreview:'Preview',
  LiveQuizStatusStarting:'Starting soon',
  LiveQuizStatusClosed:'Closed',
  LiveQuizMaxRewardHint:'Complete {count} questions to earn',
  LiveQuizPassedPlayers:'{count} players passed',
  LiveQuizStatusStarted:'Started',
  LiveQuizUnableToJoin:'Unable to join',
  LiveQuizMissedEntry:'This round has started. Players who did not enter the lobby before the start cannot join midway.',
  LiveQuizLobbyAvailableInTenMinutes:'The lobby opens 10 minutes before the quiz starts.',
  LiveQuizTomorrowReservedHint:'The quiz has not started. Remember to join tomorrow.',
  LiveQuizNotStarted:'Not started',
  LiveQuizWinnerInfo:'Winner Info',
  LiveQuizWinnerReceived:'{name} received {points} pts',
  LiveQuizRound:'Round',
  LiveQuizUltimateQuiz:'Quiz Ultimate',
  LiveQuizHome:'Home',
  LiveQuizWinYourPrizes:'Win your prizes',
  LiveQuizRoundOver:'Round over',
  LiveQuizCalculatingPassRewards:'Calculating pass rewards...',
  LiveQuizNextMatch:'Next match {time}',
  LiveQuizPts:'pts',
  LiveQuizLoyalty:'Loyalty',
  LiveQuizAveragePassReward:'Average Prize Per Winner',
  LiveQuizTimeRemainingToStart:'Time remaining to start',
  LiveQuizMinute:'min',
  LiveQuizSecond:'sec',
  LiveQuizParticipants:'{count} participants',
  LiveQuizPrizePool:'The prize pool for this game is',
  LiveQuizCompleteAllToShare:'{count} questions. Complete all to share the prize.',
  LiveQuizPleasePrepare:'Please prepare',
  LiveQuizSelected:'Selected',
  LiveQuizSelectedHint:'You\'ve selected. The correct answer will be revealed after the countdown ends.',
  LiveQuizChooseAnswer:'Choose an answer before the countdown ends.',
  LiveQuizCorrectNextQuestion:'Correct answer, next question in {seconds}s.',
  LiveQuizWrongContinueSpectating:'Wrong answer. You can continue spectating.',
}



// WEBPACK FOOTER //
// ./src/assets/i18n/en.js